import "jquery-ui/themes/base/all";
import "themes/general/desktop";
import "themes/flygcity/desktop";

import "components/desktop/cookie";

import "../../dep/google_analytics/desktop_triggers";
import "../../dep/skyscanner/desktop_triggers"
